import { Breadcrumbs, Grid, Link, TextField, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import styles from './../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss'; 
import globalStyles from './../../../assets/styles/global.module.scss'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useFlowBuilderStore } from '../../../store/flowBuilderStore';
import { WorkflowContext, WorkflowContextPayload } from '../../../context/workflowContext';
import { getChatbotChannelConfigurationDataBasedOnChannel, isCurrentViewVersionPublished } from '../flowBuilder/utilityFunctions';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import EditIcon from '@mui/icons-material/Edit';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

const WorkflowHeaderText = () => {
    
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
    }

    const flagEditWorkflowTitle = useFlowBuilderStore((state) => state.flagEditWorkflowTitle); 
    const setFlagEditWorkflowTitle = useFlowBuilderStore((state) => state.setFlagEditWorkflowTitle);
    
    const { currentActiveStaticWorkflow, updateChatbotDeploymentDetails, setCurrentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    
    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [chatbotTitle, setChatbotTitle] = useState<string>("Untitled");

    const handleSaveChatbotData = async () => {
        const updatedTitle = (chatbotTitle ?? "").trim();
        const existingTitle = (currentActiveStaticWorkflow?.chatbot_name ?? "").trim();

        if (updatedTitle === existingTitle) {
            setChatbotTitle(existingTitle);
            setFlagEditWorkflowTitle(false);
            return;
        }

        if (updatedTitle) {
            const tempPayload = {
                chatbot_id: searchParams.get('workflow_id') || "",
                chatbot_name: updatedTitle,
                chatbot_channel_configuration: getChatbotChannelConfigurationDataBasedOnChannel(currentActiveStaticWorkflow),
                chatbot_step_deployment_trigger_data: currentActiveStaticWorkflow?.chatbot_version_info?.find((version) => version.chatbot_version_status_name.toLowerCase() == currentActiveStaticWorkflow.currentViewVersion.toLowerCase())?.chatbot_step_deployment_trigger_data,
                chatbot_thread_timeout_config: currentActiveStaticWorkflow?.chatbot_thread_timeout_config,
            }
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
            const res = await updateChatbotDeploymentDetails(tempPayload)
            if (res.status) {
                showSuccess("Chatbot Name Updated Successfully")
                setFlagEditWorkflowTitle(false)
                setCurrentActiveStaticWorkflow((prev: any) => ({
                    ...prev,
                    chatbot_name: updatedTitle,
                }));
            }
            else {
                handleError(res)
            }
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
        } else {
            setChatbotTitle(currentActiveStaticWorkflow?.chatbot_name ?? "Untitled")
        }
    }

    useEffect(() => {
        if (currentActiveStaticWorkflow) {
            setChatbotTitle(currentActiveStaticWorkflow?.chatbot_name)
        }
    }, [currentActiveStaticWorkflow]) 

    return (
        <>
            <Grid item>
                <Grid container alignItems={"center"} flexWrap={"nowrap"} gap={"6px"}>
                    <Grid item>
                        <Breadcrumbs
                            aria-label="breadcrumb"
                            className={`${styles.cbHeaderBreadCrumb} ${styles.staticWorkflowHeaderBreadcrumb}`}
                        >
                            <Link
                                underline="hover"
                                onClick={() => { navigate("/workflow") }}
                                className={`${styles.cbHeaderBreadCrumbsHeadText} ${globalStyles.clickable}`}
                            >
                                Chatbot
                            </Link> 
                            <Link
                                underline="hover"
                                className={`${styles.cbHeaderBreadCrumbsChatbotLabel} ${(breakPoints.smallScreen && !flagEditWorkflowTitle)  ? styles.ellipsisChatbotName : ""}`}
                            >
                                {!flagEditWorkflowTitle && (currentActiveStaticWorkflow?.chatbot_name || "Untitled")}
                            </Link>
                        </Breadcrumbs>
                    </Grid>
                    <Grid item>
                        {flagEditWorkflowTitle &&
                            <TextField
                                placeholder='Enter Chatbot Name' 
                                className={styles.chatbotNameEditTextField}
                                value={chatbotTitle}
                                onChange={(e) => setChatbotTitle(e.target.value)}
                                onBlur={() => handleSaveChatbotData()}
                                onKeyDown={(e) => {
                                    if (e.key?.toLowerCase() == "enter") {
                                        e.preventDefault();
                                        handleSaveChatbotData();
                                    }
                                }}
                                autoFocus
                            />
                        }

                        {!flagEditWorkflowTitle && !isCurrentViewVersionPublished(currentActiveStaticWorkflow) &&
                            <EditIcon
                                sx={{ width: "15px", height: "15px", color: "#000", margin: "4px 4px 0px", cursor: "pointer" }}
                                onClick={() => setFlagEditWorkflowTitle(true)}
                            />
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default WorkflowHeaderText
